export const Titles = {
  ourProgram: '運営・提携事業紹介',
  mainService: '主なサービス内容',
};
